import { Button, Tooltip } from "@mui/material";
import { LogoutOutlined } from "@mui/icons-material";
import React from "react";
import { logoutButtonSx } from "./shellChrome";

interface LogoutButtonProps {
  onLogout?: () => void;
  /** Icon-only, with the label moved to a tooltip. */
  compact?: boolean;
  sx?: object;
}

/** Shared by both shells so the one green control cannot drift between them. */
const LogoutButton = ({ onLogout, compact = false, sx }: LogoutButtonProps) => {
  const button = (
    <Button
      onClick={onLogout}
      variant="contained"
      disableElevation
      aria-label="Log out"
      startIcon={compact ? undefined : <LogoutOutlined sx={{ fontSize: 16 }} />}
      // 48 on touch, 36 where there is a pointer — the DoD's touch-target floor.
      sx={{ ...logoutButtonSx, minHeight: { xs: 48, md: 36 }, ...sx }}
    >
      {compact ? <LogoutOutlined sx={{ fontSize: 18 }} /> : "Log out"}
    </Button>
  );

  return compact ? (
    <Tooltip title="Log out" placement="right">
      {button}
    </Tooltip>
  ) : (
    button
  );
};

export default LogoutButton;
